<template>
  <div class="product-card relative bg-gray-10">
    <locale-link :to="productLink" class="image block relative w-full aspect-1.7 overflow-hidden rounded-t">
      <etg-img class="block w-full h-full object-cover" :src="`fn:${product.cover_image}`" :alt="product.name" />
      <div class="overlay absolute top-0 left-0 w-full h-full" />
    </locale-link>
    <locale-link :to="productLink" class="info block pt-3 px-2" :aria-label="product.name">
      <p class="product-card-title text-base font-medium line-clamp-1 md:mb-1">
        {{ product.name }}
      </p>
      <product-sub-info :data="product" :product-sub-info-display-order="PRODUCT_INFO_DISPLAY_ORDER" class="text-sm" />
    </locale-link>
    <product-time-slots
      v-if="product.slots"
      :product-name="product.name"
      :max-slots-count="props.maxSlotsCount"
      :time-slot-class="props.timeSlotClass"
      :is-more-shown="product.has_more_discount"
      :is-date-label-shown="true"
      :slots="product.slots"
      :link="productLink"
      time-slots-container-class="py-3 px-2"
    />
    <div v-if="tags.length > 0" class="tags absolute w-full p-3 pb-1 top-0 left-0 text-xs flex gap-1">
      <div v-for="tag in tags" :key="tag.text" class="tag py-2px px-2 rounded" :class="tag.class">{{ tag.text }}</div>
    </div>
    <!-- <favorite-button :id="product.bid!" :is-favorited="product?.is_favorite || false" class="absolute top-0 right-0 z-1" /> -->
  </div>
</template>

<script setup lang="ts">
// import FavoriteButton from '@/components/common/favorite-button.vue'
import ProductTimeSlots from '@/components/product//product-time-slots.vue'
import ProductSubInfo from '@/components/product/product-sub-info.vue'

import { useBranchStore } from '@/store/branch'

import type { ProductSubInfoType } from '@/types/product'

interface Props {
  productId: number
  maxSlotsCount?: number
  timeSlotClass?: string
}

const PRODUCT_INFO_DISPLAY_ORDER: ProductSubInfoType[] = ['ratings', 'reservations', 'price-range-symbol', 'distance']

const { t } = useI18n()

const props = defineProps<Props>()

const branchStore = useBranchStore()

const tagsMap = computed(() => ({
  hot: {
    text: t('card.tag.hot'),
    class: 'bg-pink-50 text-white',
  },
  new: {
    text: t('card.tag.new'),
    class: 'bg-orange-60 text-white',
  },
}))
const product = computed(() => branchStore.branchListItemMap[props.productId])
const productLink = computed(() => getBranchPageLink(product.value.bid))
const tags = computed(() => [...(product.value.is_hot ? [tagsMap.value.hot] : []), ...(product.value.is_new ? [tagsMap.value.new] : [])])
</script>

<style lang="scss" scoped>
.product-card {
  .overlay {
    background: linear-gradient(180deg, rgba(0, 0, 0, 0.3) 0%, rgba(0, 0, 0, 0) 100%);
  }
}
</style>
